import React from 'react'
import type { CardContentProps as MuiCardContentProps } from '@material-ui/core/CardContent'
import MuiCardContent from '@material-ui/core/CardContent'

export type CardContentProps = MuiCardContentProps

const CardContent = React.forwardRef<HTMLDivElement, CardContentProps>(function CardContent(props, ref) {
  return <MuiCardContent ref={ref} {...props} />
})

export default CardContent
